import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React, { useContext, useRef } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getStringToArray } from '../_utils/arrayUtil';

var InternalOption = function InternalOption(props, ref) {
  var _classNames;

  var optionRef = useRef(null) || ref;
  var className = props.className,
      onChangeSelect = props.onChangeSelect,
      tag = props.tag,
      value = props.value,
      searchValue = props.searchValue,
      index = props.index,
      selectedIndex = props.selectedIndex,
      isFormatVal = props.isFormatVal;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      getLangMsg = _useContext.locale.getLangMsg;

  var optionPrefixCls = getPrefixCls(prefixCls, 'quick-search');
  var optionCls = classNames(className, (_classNames = {}, _defineProperty(_classNames, "".concat(optionPrefixCls, "-option"), true), _defineProperty(_classNames, "".concat(optionPrefixCls, "-option-selected"), index === selectedIndex), _classNames));
  var optionTagCls = classNames(_defineProperty({}, "".concat(optionPrefixCls, "-option-tag"), true));
  var optionContentCls = classNames(_defineProperty({}, "".concat(optionPrefixCls, "-option-content"), true));

  var handleClick = function handleClick() {
    // setSelected(!isSelected)
    onChangeSelect && (onChangeSelect === null || onChangeSelect === void 0 ? void 0 : onChangeSelect({
      tag: tag,
      label: searchValue,
      value: value
    }));
  };

  var formatSearchValue = isFormatVal ? getStringToArray(searchValue || '').join(" ".concat(getLangMsg('Search', 'or'), " ")) : searchValue;
  return /*#__PURE__*/React.createElement("div", {
    ref: optionRef,
    className: optionCls,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("span", {
    className: optionTagCls
  }, "".concat(tag, "\uFF1A")), /*#__PURE__*/React.createElement("span", {
    className: optionContentCls,
    title: formatSearchValue
  }, formatSearchValue));
};

var Option = /*#__PURE__*/React.forwardRef(InternalOption);
Option.displayName = 'Option';
export default Option;